(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/device-services/assets/javascripts/native/native-haptic-service.js') >= 0) return;  svs.modules.push('/components/tur/device-services/assets/javascripts/native/native-haptic-service.js');

'use strict';

function convertMsToSeconds(ms) {
  return ms / 1000;
}
class NativeHapticService {
  light() {
    svs.tur.device.nativeBridge.postMessage('hapticImpactLight');
  }
  medium() {
    svs.tur.device.nativeBridge.postMessage('hapticImpactMedium');
  }
  heavy() {
    svs.tur.device.nativeBridge.postMessage('hapticImpactHeavy');
  }
  soft() {
    svs.tur.device.nativeBridge.postMessage('hapticImpactSoft');
  }
  rigid() {
    svs.tur.device.nativeBridge.postMessage('hapticImpactRigid');
  }
  success() {
    svs.tur.device.nativeBridge.postMessage('hapticNotificationSuccess');
  }
  warning() {
    svs.tur.device.nativeBridge.postMessage('hapticNotificationWarning');
  }
  error() {
    svs.tur.device.nativeBridge.postMessage('hapticNotificationError');
  }
  selectionChanged() {
    svs.tur.device.nativeBridge.postMessage('hapticSelectionChanged');
  }
  async trigger(pattern) {
    const items = Array.isArray(pattern) ? pattern : [pattern];
    for (const item of items) {
      const payload = {
        intensity: item.intensity,
        sharpness: item.sharpness,
        duration: convertMsToSeconds(item.duration)
      };
      svs.tur.device.nativeBridge.postMessage('hapticCustom', payload);
      await new Promise(resolve => {
        var _item$delay;
        setTimeout(resolve, item.duration + ((_item$delay = item.delay) !== null && _item$delay !== void 0 ? _item$delay : 0));
      });
    }
  }
}
setGlobal('svs.tur.device.NativeHapticService', NativeHapticService);

 })(window);